import React from "react";
import "./UserRequest.css";
import PublicHeader from "../../components/public/PublicHeader";
import PublicFooter from "../../components/public/PublicFooter";

const BecomePartner = () => {
    return (
        <div className="user-request-container">
            <PublicHeader />
            <section className="public-hero">
                <div className="public-container">
                    <section className="user-request-header">
                        <div className="header-content">
                            <h1>Become a Zinea Partner</h1>
                            <p>Submit your partnership request using the form below.</p>
                        </div>
                    </section>
                </div>
            </section>

            <div className="user-request-content">
                <div className="form-container">
                    <iframe
                        title="Zinea Partners Enrolment"
                        aria-label="Zinea Partners Enrolment"
                        frameBorder="0"
                        style={{ height: '500px', width: '99%', border: 'none' }}
                        src="https://forms.zohopublic.in/connectzi1/form/ZineaPartners/formperma/34wo2dVi_S41nlXLbSLj-tTmuUxhHm7jQWIMQHq8_rw"
                    />
                </div>
            </div>
            <PublicFooter />
        </div>
    );
};

export default BecomePartner;
